export default __webpack_public_path__ + "static/media/nigel_nolook.e8c2ecba.svg";